var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ALLViewer, AnnotationType } from "@@/Annotation";
import { Comparator, ReminderUnit, SchemaItemType, TriggerType } from "@@/Schema";
import { testIsMobile } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
export class TriggerStore {
    constructor() {
        this.topposition = 30;
        this.leftposition = 200;
        this.width = testIsMobile() ? 300 : 800;
        this.height = testIsMobile() ? 400 : 600;
        this.dragging = false;
        this.show = false;
        this.saving = false;
        this.text = "";
        this.editmode = false;
        this.links = [];
        this.activeaccessids = new Set([ALLViewer]);
        this.showlinksdialog = false;
        this.readonly = false;
        this.annotationtype = undefined;
        this.showextra = false;
        this.thickness = 3;
        this.strokewidth = 3;
        this.activecolumsn = new Map();
        this.triggers = new Map();
        this.activecolumn = "";
        this.newfooterrulename = "";
        this.activetriggerid = "";
        this.zindex = 0;
        this.activeparamcon = undefined;
        this.activerulecon = 'and';
        this.activeschemaite = undefined;
        this.tos = new Set();
        this.gettriggers = () => {
            const ret = [];
            for (const [cl, val] of this.triggers) {
                for (const [id, tr] of val) {
                    ret.push(tr);
                }
            }
            return ret;
        };
        this.onok = () => { };
        makeObservable(this);
    }
    getCompsFor(type) {
        if (type === undefined)
            return [];
        if (type === SchemaItemType.Boolean) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Choice) {
            return [Comparator.Equal, Comparator.Contains, Comparator.NotContains, Comparator.NotEqual];
        }
        if (type === SchemaItemType.Color) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Remote) {
            return [Comparator.Equal];
        }
        if (type === SchemaItemType.Date || type === SchemaItemType.Number) {
            return [Comparator.Equal, Comparator.Greater, Comparator.GreaterAndEqual, Comparator.Less, Comparator.LessAndEqual];
        }
        if (type === SchemaItemType.FormInput || type === SchemaItemType.Text) {
            return [Comparator.Equal, Comparator.Contains, Comparator.NotContains];
        }
        return [];
    }
    addTo(to, param) {
        if (!param.tos) {
            param.tos = [];
        }
        if (param.tos.indexOf(to) === -1) {
            param.tos.push(to);
        }
    }
    removeTo(to, param) {
        if (param.tos) {
            const index = param.tos.indexOf(to);
            if (index > -1) {
                param.tos.splice(index, 1);
            }
        }
    }
    addParamLeftCon(param, leftcon) {
        param.leftcond = leftcon;
    }
    addParamRightCon(param, rightcon) {
        param.rightcond = rightcon;
    }
    addParamRightSchemaCon(param, rightcon) {
        param.rightschemacon = rightcon;
    }
    addDescCol(param, rightcon) {
        param.itemdecriptioncol = rightcon;
    }
    addParamComp(param, rightcon) {
        param.comp = rightcon;
    }
    addParamToCondition(con, param) {
        con.params.push(param);
    }
    removeParamToCondition(con, param) {
        con.params.splice(param, 1);
    }
    setZIndex(ind) {
        this.zindex = ind;
    }
    setSaving(ind) {
        this.saving = ind;
    }
    setActiveRuleCon(con) {
        this.activerulecon = con;
    }
    addRuleCond(tri, cond) {
        tri.conds.push(cond);
        console.log("added ");
    }
    removeRuleCond(tri, index) {
        tri.conds.splice(index, 1);
    }
    setThickness(th) {
        this.thickness = th;
    }
    setColumnId(id) {
        this.activecolumn = id;
    }
    updateTriggerReminderUnits(tig, type) {
        tig.reminderunit = type;
    }
    updateTriggerValue(tig, type) {
        tig.comparevalue = type;
    }
    updateTriggerType(tig, type) {
        tig.triggertype = type;
    }
    setTrigger(tig) {
        var _a;
        if (!this.triggers.has(tig.columnid)) {
            this.triggers.set(tig.columnid, new Map());
        }
        (_a = this.triggers.get(tig.columnid)) === null || _a === void 0 ? void 0 : _a.set(tig.id, tig);
    }
    removeTrigger(columnid, tig) {
        var _a;
        (_a = this.triggers.get(columnid)) === null || _a === void 0 ? void 0 : _a.delete(tig);
    }
    setSWidth(th) {
        this.strokewidth = th;
    }
    setShowExtraOptions(show) {
        this.showextra = show;
    }
    setActiveAnnotationType(type) {
        this.annotationtype = type;
    }
    setShowLinksDialog(show) {
        this.showlinksdialog = show;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    setReadonly(readonly) {
        this.readonly = readonly;
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    removeActiveAccessId(id) {
        this.activeaccessids.delete(id);
    }
    clearActiveAccessId() {
        this.activeaccessids.clear();
    }
    deleteLink(link) {
        const id = this.links.indexOf(link);
        if (id !== undefined && id > -1) {
            this.links.splice(id, 1);
        }
    }
    clearLinks() {
        this.links.splice(0, this.links.length);
    }
    setLink(link) {
        this.links.push(link);
    }
    setContent(content) {
        this.text = content;
    }
    setEditMode(edit) {
        this.editmode = edit;
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setToppos(pos) {
        this.topposition = pos;
    }
    setLeftPos(pos) {
        this.leftposition = pos;
    }
    reset() {
        this.activeaccessids = new Set([ALLViewer]);
        this.showextra = false;
        this.activecolumn = '';
        this.newfooterrulename = '';
        this.activecolumsn.clear();
        this.activetriggerid = '';
        this.triggers.clear();
        this.tos.clear();
    }
    addCols(col) {
        this.activecolumsn.set(col.id, col);
    }
    setActiveTriggerId(id) {
        this.activetriggerid = id;
    }
    addNewTrigger(type) {
        const trg = {
            id: Math.random() + '_' + new Date().getTime(),
            columnid: this.activecolumn,
            reminderunit: ReminderUnit.hr,
            triggertype: type,
            name: this.newfooterrulename,
            comparevalue: '',
            conds: [],
            itemdecriptioncol: '',
            tos: []
        };
        this.setTrigger(trg);
        this.setActiveTriggerId(trg.id);
    }
    setNewTrigger(name) {
        this.newfooterrulename = name;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "topposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "leftposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "text", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], TriggerStore.prototype, "links", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], TriggerStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], TriggerStore.prototype, "showlinksdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "readonly", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], TriggerStore.prototype, "annotationtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "showextra", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "thickness", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "strokewidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], TriggerStore.prototype, "activecolumsn", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], TriggerStore.prototype, "triggers", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], TriggerStore.prototype, "activecolumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "newfooterrulename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "activetriggerid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "activeparamcon", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TriggerStore.prototype, "activerulecon", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], TriggerStore.prototype, "tos", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addTo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "removeTo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addParamLeftCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addParamRightCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addParamRightSchemaCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addDescCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addParamComp", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addParamToCondition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "removeParamToCondition", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setActiveRuleCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addRuleCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "removeRuleCond", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setThickness", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setColumnId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "updateTriggerReminderUnits", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "updateTriggerValue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "updateTriggerType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setTrigger", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "removeTrigger", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setSWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setShowExtraOptions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setActiveAnnotationType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setShowLinksDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setReadonly", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "removeActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "clearActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "deleteLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "clearLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setToppos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setLeftPos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "addCols", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setActiveTriggerId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TriggerStore.prototype, "setNewTrigger", null);
